// Filtros.jsx
import React, {useState, useEffect} from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Select_simple, Input } from './ui';
import {optionsObjeto_Tramitacion_Pagos, optionsDocumentacionPresentada, optionsOrganismoSolicitante, optionsEtapaPago, optionsAvanceObra, optionsPartido, optionsEncargadoProyecto, optionsEncargadoRendicion} from '../datos/options';

const FiltrosTramitacionProyectos = ({ filters, data, onFilterChange, limpiarFiltros }) => {
	const [referentePoliticoUnicos, setReferentePoliticoUnicos] = useState([]);
	const [ongsUnicas, setOngsUnicas] = useState([]);
	
	useEffect(() => {
		// Filtrar valores nulos, indefinidos o vacíos para referente político
		const nombresUnicos = new Set(
			data
				.map(item => item.referente_politico_nombre)
				.filter(nombre => nombre && nombre.trim() !== '')
		);
		
		// Crear opciones para el select de referente político
		const arrayReferentePolitico = Array.from(nombresUnicos).map(nombre => ({
			value: nombre,
			label: nombre
		}));
		setReferentePoliticoUnicos(arrayReferentePolitico);

		// Obtener solo ONGs/Cooperativas (excluyendo municipios)
		const ongsUnicasSet = new Set();
		
		// Filtrar solo las entradas que son ONGs/Cooperativas
		data.forEach(item => {
		    // Solo incluir si es un subsidio a ONG/Cooperativa
		    if (item.organismo_solicitante && 
		        item.organismo_solicitante.trim() !== '' &&
		        !item.organismo_solicitante.startsWith('Municipio de ')) {
		        ongsUnicasSet.add(item.organismo_solicitante);
		    }
		});

		// Ordenar alfabéticamente y crear opciones para el select de ONGs
		const opcionesOngs = Array.from(ongsUnicasSet)
		    .sort((a, b) => a.localeCompare(b, 'es', {sensitivity: 'base'}))
		    .map(ong => ({
		        value: ong,
		        label: ong.replace(/^ONG\s*/i, '') // Eliminar prefijo 'ONG ' si existe
		    }));

		setOngsUnicas(opcionesOngs);
	}, [data]);
	
	return (
		<div className="mb-6 p-4 border border-gray-200 rounded-lg bg-white shadow-sm dark:bg-gray-800 dark:border-gray-700">

			<div className="flex justify-between items-center mb-4">
				<div className="flex items-center">
					<h2 className="text-lg font-semibold text-gray-800 dark:text-white">Filtros</h2>
					{/*<InfoButtonWithPopover infoText="EN DESARROLLO" />*/}
				</div>

				<Button
					onClick={limpiarFiltros}
					className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white rounded-md transition-colors"
				>
					Limpiar filtros
				</Button>
			</div>
			{/* Primera fila - 4 columnas */}
			<div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* Filtro por Partido */}
                <div>
                    <label htmlFor="partido_nombre" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Partido
                    </label>                                   
                    <Select_simple
                        id="partido_nombre"
                        name="partido_nombre"
                        value={filters.partido_nombre}
                        onChange={(e) => onFilterChange('partido_nombre', e.target.value)}
                        options={optionsPartido}
                        label="Partido"
                        placeholder="Todos los trámites por Partido"
                    />
                </div>

                {/* Filtro por Organismo Solicitante */}
                <div>
                    <label htmlFor="organismo_solicitante" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Organismo Solicitante
                    </label>
                    <Select_simple
                        name="organismo_solicitante"
                        value={filters.organismo_solicitante}
                        onChange={(e) => onFilterChange('organismo_solicitante', e.target.value)}
                        options={optionsOrganismoSolicitante}
                        label="Organismo Solicitante"
                        placeholder="Todos los trámites por Organismo Solicitante"
                    />
                </div>

                {/* Filtro por ONG */}
                <div>
                    <label htmlFor="ong" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        ONG/Cooperativa
                    </label>
                    <Select_simple
                        id="ong"
                        name="ong"
                        value={filters.ong}
                        onChange={(e) => onFilterChange('ong', e.target.value)}
                        options={ongsUnicas}
                        label="ONG/Cooperativa"
                        placeholder="Todos los trámites por ONG/Cooperativa"
                        isClearable
                    />
                </div>

                {/* Filtro por Encargado de Rendición */}
                <div>
                    <label htmlFor="encargado_rendicion" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Encargado de Rendición
                    </label>
                    <Select_simple
                        id="encargado_rendicion"
                        name="encargado_rendicion"
                        value={filters.encargado_rendicion}
                        onChange={(e) => onFilterChange('encargado_rendicion', e.target.value)}
                        options={optionsEncargadoRendicion}
                        label="Encargado de Rendición"
                        placeholder="Todos los trámites por Encargado de Rendición"
                    />
                </div>
            </div>

            {/* Segunda fila - 4 columnas */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
                {/* Filtro por Encargado de Proyecto */}
                <div>
                    <label htmlFor="encargado_proyecto" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Encargado de Proyecto
                    </label>
                    <Select_simple
                        name="encargado_proyecto"
                        value={filters.encargado_proyecto}
                        onChange={(e) => onFilterChange('encargado_proyecto', e.target.value)}
                        options={optionsEncargadoProyecto}
                        label="Encargado de Proyecto"
                        placeholder="Todos los trámites por Encargado de Proyecto"
                    />
                </div>

                {/* Filtro por Referente Político */}
                <div>
                    <label htmlFor="referente_politico_nombre" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Referente Político
                    </label>
                    <Select_simple
                        name="referente_politico_nombre"
                        value={filters.referente_politico_nombre}
                        onChange={(e) => onFilterChange('referente_politico_nombre', e.target.value)}
                        options={referentePoliticoUnicos}
                        label="Referente Político"
                        placeholder="Todos los trámites por Referente Político"
                        isClearable
                    />
                </div>

                {/* Filtro por Avance Financiero */}
                <div>
                    <label htmlFor="avance_financiero" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Avance Financiero
                    </label>
                    <Select_simple
                        name="avance_financiero"
                        value={filters.avance_financiero}
                        onChange={(e) => onFilterChange('avance_financiero', e.target.value)}
                        options={optionsEtapaPago}
                        label="Avance Financiero"
                        placeholder="Todos los trámites por Avance Financiero"
                    />
                </div>

                {/* Filtro por Avance Obra */}
                <div>
                    <label htmlFor="avance_obra" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Avance de Obra
                    </label>
                    <Select_simple
                        name="avance_obra"
                        value={filters.avance_obra}
                        onChange={(e) => onFilterChange('avance_obra', e.target.value)}
                        options={optionsAvanceObra}
                        label="Avance de Obra"
                        placeholder="Todos los trámites por Avance de Obra"
                    />
                </div>
            </div>

            {/* Tercera fila - Grid de 4 columnas */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
                {/* Filtro por Fecha Inicio - 1 columna */}
                <div className="md:col-span-1">
                    <div className="flex flex-col h-full">
                        <label htmlFor="fechaInicio" className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Fecha Inicio Obra
                        </label>
                        <DatePicker
                            id="fechaInicio"
                            selected={filters.fechaInicioObra}
                            onChange={(date) => onFilterChange('fechaInicioObra', date)}
                            dateFormat="dd/MM/yyyy"
                            className="w-full p-2 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            placeholderText="Todos los trámites por Fecha Inicio de Obra"
                        />
                    </div>
                </div>

                {/* Filtro por Fecha Fin - 1 columna */}
                <div className="md:col-span-1">
                    <div className="flex flex-col h-full">
                        <label htmlFor="fechaFin" className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Fecha Fin Obra
                        </label>
                        <DatePicker
                            id="fechaFin"
                            selected={filters.fechaFinObra}
                            onChange={(date) => onFilterChange('fechaFinObra', date)}
                            dateFormat="dd/MM/yyyy"
                            className="w-full p-2 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            placeholderText="Todos los trámites por Fecha Fin Obra"
                        />
                    </div>
                </div>

                {/* Cuadro de búsqueda - 2 columnas */}
                <div className="md:col-span-2">
                    <div className="flex flex-col h-full">
                        <label htmlFor="searchQuery" className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Buscar
                        </label>
                        <Input
                            type="search"
                            id="searchQuery"
                            placeholder="Buscar por Id, Nombre de Obra o Expediente de Proyecto..."
                            value={filters.searchQuery}
                            onChange={(e) => onFilterChange('searchQuery', e.target.value)}
                            className="w-full h-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 dark:text-gray-200 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />
                    </div>
                </div>
            </div>
		</div>
	);
};

export default FiltrosTramitacionProyectos;